import ApiService from "@/services/api.service";

class DemoUserService extends ApiService {
  constructor() {
    super();
  }

  public async getAllDemoUser(): Promise<string[]> {
    const url = "/api/DemoUser";
    const response = await this.axiosInstance.get<string[]>(url);
    return response.data;
  }
}

export default new DemoUserService();
